import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp, ArrowUp, Flame } from "lucide-react";
import api from "../lib/api";

export default function RisingThisWeek() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/awards/rising?days=7&limit=3").then((r) => setRows(r.data || [])).catch(() => {});
  }, []);

  if (!rows.length) return null;

  return (
    <section data-testid="rising-this-week" className="px-3 sm:px-6 md:px-10 mt-8 max-w-6xl mx-auto">
      <div className="flex items-end justify-between mb-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-tv-accent font-bold flex items-center gap-2">
            <Flame className="w-3.5 h-3.5" /> Rising this week
          </div>
          <h3 className="font-display font-bold text-2xl sm:text-3xl text-white tracking-tight mt-1">Biggest vote jumps</h3>
        </div>
        <Link to="/awards" className="text-xs text-white/60 hover:text-white">See full leaderboard →</Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {rows.map((r, i) => {
          const trendColor = r.delta > 0 ? "text-green-400" : "text-white/40";
          return (
            <Link
              key={r.creator_id}
              to={`/creator/${r.creator_id}`}
              data-testid={`rising-card-${i}`}
              className="tv-glass rounded-2xl p-4 flex items-center gap-4 relative overflow-hidden group hover:border-tv-accent/40 border border-white/5 transition"
            >
              <div className={`absolute top-3 right-3 font-display font-black ${i === 0 ? "text-tv-accent" : "text-white/30"} text-3xl`}>
                #{i + 1}
              </div>
              {r.picture ? (
                <img src={r.picture} alt="" className="w-16 h-16 rounded-full object-cover border-2 border-white/10" />
              ) : (
                <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center text-xl text-white/40">?</div>
              )}
              <div className="flex-1 min-w-0">
                <div className="font-display font-bold text-white text-lg truncate">{r.name}</div>
                <div className="text-[10px] uppercase tracking-wider text-white/50">{(r.role || "").replace("_", " ")}</div>
                <div className={`flex items-center gap-1.5 mt-2 font-bold text-sm ${trendColor}`}>
                  <ArrowUp className="w-4 h-4 animate-bounce" />
                  <span>+{r.delta} votes</span>
                  {r.pct_jump != null && (
                    <span className="text-xs opacity-80">({r.pct_jump > 0 ? "+" : ""}{r.pct_jump}%)</span>
                  )}
                </div>
                <div className="text-[10px] text-white/40 mt-0.5">
                  {r.votes_this_period} this week · {r.votes_prev_period} last week
                </div>
              </div>
              <TrendingUp className="w-5 h-5 text-tv-accent opacity-0 group-hover:opacity-100 transition absolute bottom-3 right-3" />
            </Link>
          );
        })}
      </div>
    </section>
  );
}
